module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"pageTitle":"Benutzer bearbeiten","firstNameLabel":"Vorname","lastNameLabel":"Nachname","companyNameLabel":"Firma","emailLabel":"E-Mail","errorEmailInvalid":"Ungültige E-Mail-Adresse","submitButtonLabel":"Speichern","cancelButtonLabel":"Abbrechen"}}')
  delete Component.options._Ctor
}
